import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import moment from 'moment';

import { CompanySettingsService } from 'src/app/reusables/services/company-settings.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { PointStoreProductCardBaseService } from '../../services/point-store-product-card-base.service';
import { PointStoreProductEditService } from '../../services/point-store-product-edit.service';
import { PointStorePermissionService } from '../../services/point-store-permission.service';
import { PointStoreCategoriesService } from '../../services/point-store-categories.service';

@Component({
  selector: 'cv-point-store-product-landing-card-cv',
  templateUrl: './point-store-product-landing-card-cv.component.html',
  styleUrls: ['./point-store-product-landing-card-cv.component.scss']
})
export class PointStoreProductLandingCardCvComponent implements OnInit {

  @Input() product: any;

  @Output() editPointStoreProduct = new EventEmitter<any>();
  @Output() copyPointStoreProduct = new EventEmitter<any>();
  @Output() removePointStoreProduct = new EventEmitter<any>();


  DateFormat = CVAngularDateFormat;
  pspes: any = null;
  LocalizationMessages: any = null;

  constructor(
    private companySettingsService: CompanySettingsService,
    private pointStoreProductEditService: PointStoreProductEditService,
    private cvLocalizationService: CVLocalizationService,
    public baseCardService: PointStoreProductCardBaseService,
    private pointStorePermissionService: PointStorePermissionService,
    private pointStoreCategoriesService: PointStoreCategoriesService,
  ) { }

  ngOnInit(): void {
    this.pspes = this.pointStoreProductEditService.pointStoreProductEditObj;
    this.loadLocalizationsMessages();
  }

  async edit(product: any) {
    const check = await this.baseCardService.checkSinglePermission(this.pointStorePermissionService.getEditPermissionName());
    if (check) {
      this.editPointStoreProduct.emit(product);
      this.pointStoreCategoriesService.resetCategoriesList();
    }
  }

  async copy(product: any) {
    const check = await this.baseCardService.checkSinglePermission(this.pointStorePermissionService.getCreatePermissionName());
    if (check) {
      this.copyPointStoreProduct.emit(product);
      this.pointStoreCategoriesService.resetCategoriesList();
    }
  }

  async remove(product: any) {
    const check = await this.baseCardService.checkSinglePermission(this.pointStorePermissionService.getEditPermissionName());
    if (check) {
      this.removePointStoreProduct.emit(product);
    }
  }

  loadLocalizationsMessages() {
    this.cvLocalizationService.GetSection("MarketPlace_Management_Messages").then(
      (result) => {
        this.LocalizationMessages = result;
      }
    );
  }

  getLocalizationString(key, defaultValue) {
    if (this.LocalizationMessages && this.LocalizationMessages.has(key))
        return this.LocalizationMessages.get(key);
    return defaultValue;
}

  computeSalePrice(product) {
    return Math.ceil(product.Price - ((product.Sale / 100.0) * product.Price));
  };

  calculateInitialVariationPrice(product) {
    if (!product.VariationsData || product.VariationsData.length === 0 ) {
      return 0;
    }
    let initialVariationPrice = 0;
    let initialVariation = product.VariationsData.reduce((prev, curr) => {
      let prevValue = prev.VariationPrice;
      let currValue = curr.VariationPrice;
      if (prev.VariationOnSale)
        prevValue = prev.VariationPrice - (prev.VariationPrice * (product.Sale / 100));
      if (curr.VariationOnSale)
        currValue = curr.VariationPrice - (curr.VariationPrice * (product.Sale / 100));
      return prevValue < currValue ? prev : curr;
    });

    if (initialVariation.VariationOnSale)
      initialVariationPrice = Math.ceil(initialVariation.VariationPrice - ((product.Sale / 100.0) * initialVariation.VariationPrice))
    else
      initialVariationPrice = initialVariation.VariationPrice;

    return initialVariationPrice;
  }

  calculateLastVariationPrice(product) {
    if (!product.VariationsData || product.VariationsData.length === 0 ) {
      return 0;
    }
    let lastVariationPrice = 0;
    let lastVariation = product.VariationsData.reduce((prev, curr) => {
      let prevValue = prev.VariationPrice;
      let currValue = curr.VariationPrice;
      if (prev.VariationOnSale)
        prevValue = prev.VariationPrice - (prev.VariationPrice * (product.Sale / 100));
      if (curr.VariationOnSale)
        currValue = curr.VariationPrice - (curr.VariationPrice * (product.Sale / 100));
      return prevValue > currValue ? prev : curr;
    });
    if (lastVariation.VariationOnSale)
      lastVariationPrice = Math.ceil(lastVariation.VariationPrice - ((product.Sale / 100.0) * lastVariation.VariationPrice))
    else
      lastVariationPrice = lastVariation.VariationPrice;
    return lastVariationPrice;
  }

  getTitle(product, type) {
    let title = "";
    let onGoingMessage = " - OnGoing";

    if (this.LocalizationMessages != undefined) {
      onGoingMessage = " - " + this.LocalizationMessages.get("OnGoing");
    }

    const coinToCurrencyRatio = this.companySettingsService.getCompanyValueByFieldName("CoinToCurrencyValue");
    switch (type) {
      case "carousel":
        if (product.CarouselStart != null)
          title = moment(product.CarouselStart).format("l") + (product.CarouselEnd != null ? (" - " + moment(product.CarouselEnd).format("l")) : onGoingMessage);
        break;
      case "featured":
        if (product.FeatureStart != null)
          title = moment(product.FeatureStart).format("l") + (product.FeatureEnd != null ? (" - " + moment(product.FeatureEnd).format("l")) : onGoingMessage);
        break;
      case "sale":
        if (product.SaleStart != null)
          title = moment(product.SaleStart).format("l") + (product.SaleEnd != null ? (" - " + moment(product.SaleEnd).format("l")) : onGoingMessage);
        break;
      case "price":
        if (this.pspes == null || product.Price == null) title = "";

        if (coinToCurrencyRatio == null) title = "";
        else title = "$" + ((product.Price / coinToCurrencyRatio.NumericValue)).toFixed(2);
        break;
      case "salePrice":
        if (this.pspes == null || product.Price == null || product.Sale <= 0) title = "";

        if (coinToCurrencyRatio == null) title = "";
        else if (product.IsOnSaleChecked && this.baseCardService.showSale(product)) title = "On Sale For: $" + ((Math.ceil(product.Price - ((product.Sale / 100.0) * product.Price)) / coinToCurrencyRatio.NumericValue)).toFixed(2)
        else title = "$" + ((product.Price / coinToCurrencyRatio.NumericValue)).toFixed(2);

        break;
      case "variationsPrices":
        if (this.pspes == null || product.Price == null) title = "";

        if (coinToCurrencyRatio == null) title = "";
        else title = "$" + ((this.baseCardService.calculateInitialVariationPrice(product) / coinToCurrencyRatio.NumericValue)).toFixed(2) + " - $" + ((this.baseCardService.calculateLastVariationPrice(product) / coinToCurrencyRatio.NumericValue)).toFixed(2);
        break;
    }
    return title;
  };

  displayProductImg(product){
    let img: string = "";
    if(!(product.ProductImageID > 0 || this.baseCardService.isMainImageEmptyWithMultiplesImages(product))){
      img = '../Admin/ImageResizer.aspx?imgid=-16&w=auto&h=80';
    }else if(product.ProductImageID > 0 ){
      img = '../Admin/ImageResizer.aspx?imgid=' + product.ProductImageID + '&w=auto&h=155';
    }else {
      img = '../Admin/ImageResizer.aspx?imgid=' + product.MultipleImagesData[0].PointStoreProductImageID + '&w=auto&h=155';
    }
    return img;
  }

getProductAssignment():boolean{
    if(this.product.PointStoreProductAllAssignments.emp.length >0 || this.product.PointStoreProductAllAssignments.empAssignAll){
        return true;
    }else if(this.product.PointStoreProductAllAssignments.emp.length ===0 && !this.product.PointStoreProductAllAssignments.empAssignAll){
        return false;
    }
    return false;
  }

}
